import React, { useState, useEffect } from 'react';
import ModuleTemplate from '../../ModuleTemplate';
import { useSpeakAnswer } from '../../lib/useSpeakAnswer';
import { useInstructionAudio } from '../../lib/useInstructionAudio';
import { fallbackWrongKey } from '../../lib/speechAnswerEvaluator';
import './SpatialDirections.css?v=2';

/* eslint-disable react-hooks/exhaustive-deps */

const S3_BASE_URL = 'https://7cdc3d1b-1cdd-4f85-aaa4-fa5c412f8f13.selstorage.ru';

const SpatialDirections = ({ ageGroup, onBack, onComplete }) => {
  const { start: startSpeakRecognition, stop: stopSpeakRecognition } = useSpeakAnswer('SpatialDirections');
  const { play: playInstruction, stop: stopInstruction } = useInstructionAudio();
  const questionsByAge = {
    '4': [
      { id: 1, question: 'Где мячик? Над коробкой или под коробкой?', correct: 'НАД', options: ['НАД', 'ПОД', 'В', 'ЗА'], image: `${S3_BASE_URL}/space/above.png` },
      { id: 2, question: 'А сейчас где он? На коробке или под коробкой?', correct: 'НА', options: ['ЗА', 'НА', 'В', 'ПОД'], image: `${S3_BASE_URL}/space/on.png` },
      { id: 3, question: 'Где теперь мячик? В коробке или на коробке?', correct: 'В', options: ['НАД', 'В', 'СЛЕВА', 'ПОД'], image: `${S3_BASE_URL}/space/inside.png` },
      { id: 4, question: 'Где сейчас мячик? Между или за?', correct: 'МЕЖДУ', options: ['МЕЖДУ', 'ЗА', 'НАД', 'СПРАВА'], image: `${S3_BASE_URL}/space/among.png` },
      { id: 5, question: 'Сейчас мячик справа или слева?', correct: 'СПРАВА', options: ['СЛЕВА', 'НА', 'СПРАВА', 'В'], image: `${S3_BASE_URL}/space/right.png` },
      { id: 6, question: 'А сейчас мячик справа или слева?', correct: 'СЛЕВА', options: ['ПОД', 'СЛЕВА', 'ЗА', 'НАД'], image: `${S3_BASE_URL}/space/left.png` },
      { id: 7, question: 'Где мячик за коробкой или под коробкой?', correct: 'ЗА', options: ['НА', 'ЗА', 'В', 'МЕЖДУ'], image: `${S3_BASE_URL}/space/behind.png` },
      { id: 8, question: 'А сейчас где он? За коробкой или под коробкой?', correct: 'ПОД', options: ['НАД', 'ПОД', 'СПРАВА', 'СЛЕВА'], image: `${S3_BASE_URL}/space/under.png` },
    ],
    '5': [
      { id: 1, question: 'Где мячик? Над коробкой или под коробкой?', correct: 'НАД', options: ['ПОД', 'НАД', 'В', 'МЕЖДУ'], image: `${S3_BASE_URL}/space/above.png` },
      { id: 2, question: 'А сейчас где он? На коробке или под коробкой?', correct: 'НА', options: ['ЗА', 'В', 'НА', 'ПОД'], image: `${S3_BASE_URL}/space/on.png` },
      { id: 3, question: 'Где теперь мячик? В коробке или на коробке?', correct: 'В', options: ['НАД', 'ЗА', 'В', 'СЛЕВА'], image: `${S3_BASE_URL}/space/inside.png` },
      { id: 4, question: 'Где сейчас мячик? Между или за?', correct: 'МЕЖДУ', options: ['СПРАВА', 'НА', 'МЕЖДУ', 'ПОД'], image: `${S3_BASE_URL}/space/among.png` },
      { id: 5, question: 'Сейчас мячик справа или слева?', correct: 'СПРАВА', options: ['СЛЕВА', 'СПРАВА', 'ЗА', 'НАД'], image: `${S3_BASE_URL}/space/right.png` },
      { id: 6, question: 'А сейчас мячик справа или слева?', correct: 'СЛЕВА', options: ['В', 'ПОД', 'НА', 'СЛЕВА'], image: `${S3_BASE_URL}/space/left.png` },
      { id: 7, question: 'Где мячик за коробкой или под коробкой?', correct: 'ЗА', options: ['МЕЖДУ', 'ЗА', 'НАД', 'НА'], image: `${S3_BASE_URL}/space/behind.png` },
      { id: 8, question: 'А сейчас где он? За коробкой или под коробкой?', correct: 'ПОД', options: ['НАД', 'ПОД', 'СПРАВА', 'СЛЕВА'], image: `${S3_BASE_URL}/space/under.png` },
    ],
    '6': [
      { id: 1, question: 'Где мячик? Над коробкой или под коробкой?', correct: 'НАД', options: ['НАД', 'ЗА', 'В', 'СЛЕВА'], image: `${S3_BASE_URL}/space/above.png` },
      { id: 2, question: 'А сейчас где он? На коробке или под коробкой?', correct: 'НА', options: ['ПОД', 'МЕЖДУ', 'НА', 'ЗА'], image: `${S3_BASE_URL}/space/on.png` },
      { id: 3, question: 'Где теперь мячик? В коробке или на коробке?', correct: 'В', options: ['СПРАВА', 'НАД', 'ПОД', 'В'], image: `${S3_BASE_URL}/space/inside.png` },
      { id: 4, question: 'Где сейчас мячик? Между или за?', correct: 'МЕЖДУ', options: ['В', 'ЗА', 'МЕЖДУ', 'НА'], image: `${S3_BASE_URL}/space/among.png` },
      { id: 5, question: 'Сейчас мячик справа или слева?', correct: 'СПРАВА', options: ['СЛЕВА', 'НАД', 'В', 'СПРАВА'], image: `${S3_BASE_URL}/space/right.png` },
      { id: 6, question: 'А сейчас мячик справа или слева?', correct: 'СЛЕВА', options: ['ПОД', 'СЛЕВА', 'МЕЖДУ', 'ЗА'], image: `${S3_BASE_URL}/space/left.png` },
      { id: 7, question: 'Где мячик за коробкой или под коробкой?', correct: 'ЗА', options: ['НА', 'ПОД', 'ЗА', 'СПРАВА'], image: `${S3_BASE_URL}/space/behind.png` },
      { id: 8, question: 'А сейчас где он? За коробкой или под коробкой?', correct: 'ПОД', options: ['НАД', 'В', 'СЛЕВА', 'ПОД'], image: `${S3_BASE_URL}/space/under.png` },
    ],
  };

  const questions = questionsByAge[ageGroup] || questionsByAge['4'];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [answerLog, setAnswerLog] = useState([]);
  const [selected, setSelected] = useState(null);
  const [showResult, setShowResult] = useState(false);
  const [isListening, setIsListening] = useState(false);
  const [isBotSpeaking, setIsBotSpeaking] = useState(false);
  const [recognizerReady, setRecognizerReady] = useState(false);
  const [answeredByClick, setAnsweredByClick] = useState(false);

  const currentQuestion = questions[currentIndex];
  const totalQuestions = questions.length;

  const handleSelect = (option, fromClick = false) => {
    if (selected !== null) return;
    stopInstruction();
    stopSpeakRecognition();
    setIsListening(false);
    setAnsweredByClick(fromClick);
    setSelected(option);
    const isCorrect = option === currentQuestion.correct;
    setAnswers([...answers, isCorrect]);
    setAnswerLog(prev => [...prev, { correct: currentQuestion.correct, chosen: option, isCorrect }]);
    setTimeout(() => {
      if (currentIndex < totalQuestions - 1) { setCurrentIndex(currentIndex + 1); setSelected(null); setAnsweredByClick(false); }
      else { setShowResult(true); }
    }, 1000);
  };

  // Start connecting the recognizer at the same time as the voiceover
  // (instead of only after it finishes) so it's already listening by the
  // time the child hears the question — previously there was a dead-air gap
  // where an eager answer would be missed. useSpeakAnswer's own timeout
  // (8s) is the "no answer" safety net; a timeout/unrecognized word resolves
  // to some wrong option rather than silently marking the question correct.
  const askQuestion = () => {
    if (!currentQuestion) return;
    setIsBotSpeaking(true);
    setIsListening(false);
    setRecognizerReady(false);

    startSpeakRecognition(
      currentQuestion.options.map((option) => ({ key: option, text: option })),
      {
        timeoutMs: 12000,
        onListening: () => setRecognizerReady(true),
        onResult: ({ matchedKey }) => {
          const resolvedKey = matchedKey || fallbackWrongKey(
            currentQuestion.options.map((o) => ({ key: o })),
            currentQuestion.correct
          );
          handleSelect(resolvedKey, false);
        },
      }
    );
    console.log('currentQuestion.question', currentQuestion.question);
    playInstruction(currentQuestion.question, () => setIsBotSpeaking(false));
  };

  useEffect(() => {
    askQuestion();
  }, [currentIndex]);

  const repeatInstruction = () => {
    if (!currentQuestion) return;
    stopSpeakRecognition();
    askQuestion();
  };

  useEffect(() => {
    setIsListening(!isBotSpeaking && recognizerReady && selected === null);
  }, [isBotSpeaking, recognizerReady, selected]);

  useEffect(() => {
    if (showResult) {
      const timer = setTimeout(() => {
        const correctCount = answers.filter(a => a === true).length;
        const score = totalQuestions > 0 ? Math.round((correctCount / totalQuestions) * 100) : 0;
        const correctPrepositions = [...new Set(answerLog.filter(a => a.isCorrect).map(a => a.correct))];
        const failedPrepositions = [...new Set(answerLog.filter(a => !a.isCorrect).map(a => a.correct))];
        const confusedPairs = [];
        const seenPairs = new Set();
        answerLog.forEach(({ correct, chosen, isCorrect }) => {
          if (isCorrect) return;
          const key = `${correct}->${chosen}`;
          if (!seenPairs.has(key)) { seenPairs.add(key); confusedPairs.push({ expected: correct, chosen }); }
        });

        if (onComplete) {
          onComplete({ testId: 'SpatialDirections', score, details: { total: totalQuestions, correct: correctCount, correctPrepositions, failedPrepositions, confusedPairs } });
        } else { onBack(); }
      }, 4000);
      return () => clearTimeout(timer);
    }
  }, [showResult]);
  
  if (showResult) {
    const correctCount = answers.filter(a => a === true).length;
    return (
      <ModuleTemplate progress={answers} totalQuestions={totalQuestions} forceStop={true} onComplete={onComplete || onBack}>
        <div className="result-content">
          <h2 className="result-title">🎉 Упражнение завершено!</h2>
          <div className="result-score">
            <span className="score-number">{correctCount}</span>
            <span className="score-total"> / {totalQuestions}</span>
          </div>
        </div>
      </ModuleTemplate>
    );
  }

  return (
    <ModuleTemplate 
      progress={answers} 
      totalQuestions={totalQuestions} 
      forceStop={true} 
      onComplete={onComplete || onBack}
      onRepeat={repeatInstruction}
      extraContent={currentQuestion.question}
    >
      <div className="spatial-container">
        <div className="spatial-main-row">
          
          <div className="spatial-options-col">
            {currentQuestion.options.map((option) => (
              <button key={option} className={`spatial-option-btn ${selected === option && answeredByClick ? 'selected' : ''}`} onClick={() => handleSelect(option, true)} disabled={selected !== null}>{option}</button>
            ))}
          </div>
          
          <div className="spatial-scene">
            <img src={currentQuestion.image} alt="Сцена" className="spatial-scene-image" onError={(e) => { e.target.src = '/placeholder.png'; }} />
          </div>
         
          <div className="spatial-indicators-col">
            <div className={`indicator listen ${isBotSpeaking ? 'active' : ''}`}>
              <span className="indicator-icon">🔊</span>
            </div>
            <div className={`indicator speak ${isListening ? 'active' : ''}`}>
              <span className="indicator-icon">🎤</span>
            </div>
          </div>

        </div>
      </div>
    </ModuleTemplate>
  );
};

export default SpatialDirections;